import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { SharedModule } from '../../../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ProductManagementComponent } from './components/product-management/product-management.component';
import { EasykashAddProductComponent } from './components/easykash-add-product/easykash-add-product.component';
import { QuickCashComponent } from './components/quick-cash/quick-cash.component';
import { QuickQassatlyComponent } from './components/quick-qassatly/quick-qassatly.component';
import { PermissionsGuardService } from '../../../shared/services/permissions-guard.service';
import { AuthGuardService as AuthGuard } from '../../../shared/services/auth.guard';
import { AddBulkComponent } from './components/collections/add-bulk/add-bulk.component';

const paymentPagesRoutes: Routes = [
  {
    path: 'products/management',
    component: ProductManagementComponent,
    canActivate: [PermissionsGuardService, AuthGuard]
  },
  { path: 'new-bulk', component: AddBulkComponent },
  { path: 'claims/management', loadChildren: () => import('./components/collections/claims-management/claims-management.module').then(m => m.ClaimsManagementModule) },
  { path: 'new-products/claim', loadChildren: () => import('./components/collections/claim/claim.module').then(m => m.ClaimModule) },
  { path: 'new-products/invoice', loadChildren: () => import('./components/invoice/invoice.module').then(m => m.InvoiceModule) },
  { path: 'new-products/event', loadChildren: () => import('./components/event/event.module').then(m => m.EventModule) },
  { path: 'new-products/physical', loadChildren: () => import('./components/physical-product/physical-product.module').then(m => m.PhysicalProductModule) },
  { path: 'new-products/subscription', loadChildren: () => import('./components/subscription/subscription.module').then(m => m.SubscriptionModule) },
  { path: 'new-products/quick-payment',  loadChildren: () => import('./components/quick-payment/quick-payment.module').then(m => m.QuickPaymentModule)},
  { path: 'new-products/quick-cash', component: QuickCashComponent },
  { path: 'new-products/quick-qassatly', component: QuickQassatlyComponent },
  { path: 'new-products/calendar', loadChildren: () => import('./components/booking/calendar.module').then(m => m.BookingModule) },
  { path: 'new-products/reservation', loadChildren: () => import('./components/reservation/reservation.module').then(m => m.ReservationModule) },
  { path: 'new-products/basic-info',loadChildren: () => import('./components/basic-info/basic-info.module').then(m => m.BasicInfoModule) }
];

@NgModule({
  declarations: [
    ProductManagementComponent,
    EasykashAddProductComponent,
    QuickCashComponent,
    QuickQassatlyComponent,
    AddBulkComponent,
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(paymentPagesRoutes),
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
  ]
})

export class PaymentPagesModule { }
